<template>
  <div
    v-if="showBar"
    class="admin-pagination-bar d-flex justify-content-between align-items-center mt-1 px-50 pb-50"
  >
    <small class="text-muted">{{ label }}</small>
    <b-pagination
      :value="page"
      :total-rows="total"
      :per-page="perPage"
      size="sm"
      pills
      prev-text="Previous"
      next-text="Next"
      @input="onInput"
    />
  </div>
</template>

<script>
import { BPagination } from 'bootstrap-vue'
import { paginationShowingLabel } from '@/utils/adminApiHelpers'

export default {
  name: 'AdminPaginationBar',
  components: { BPagination },
  props: {
    page: { type: Number, required: true },
    perPage: { type: Number, required: true },
    total: { type: Number, default: 0 },
    hideWhenSinglePage: { type: Boolean, default: false },
  },
  computed: {
    showBar() {
      if (!this.total) return false
      if (this.hideWhenSinglePage && this.total <= this.perPage) return false
      return true
    },
    label() {
      return paginationShowingLabel(this.page, this.perPage, this.total)
    },
  },
  methods: {
    onInput(nextPage) {
      const page = Number(nextPage) || 1
      if (page !== this.page) {
        this.$emit('change', page)
      }
    },
  },
}
</script>
